import { createSlice } from "@reduxjs/toolkit";

// ---- import from local actions ----
import { fetchControlCodeList } from "./../actions/ControlCodeActions";


const ControlCodeSlice = createSlice({
    name: "controlCode",
    initialState: {
        controlCodeList: {
          data: [],
          status: 'idle',
          error: "",
          loading: false,
      },
    },
    
    extraReducers: (builder) => {
      builder
        .addCase(fetchControlCodeList.pending, (state) => {
          state.controlCodeList.status = 'loading';
        })
        .addCase(fetchControlCodeList.fulfilled, (state, action) => {
            state.controlCodeList.status = 'idle';
            state.controlCodeList.data = action.payload.result;
        })
        .addCase(fetchControlCodeList.rejected, (state, action) => {
          state.controlCodeList.status = 'rejected';
          state.controlCodeList.error = action.error.message;
        })
    },
});


export default ControlCodeSlice.reducer;
